import template from "./bHeader.html";

export function bHeaderDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    scope: {
      user: "=?",
      client: "=",
      processGroup: "=",
      workData: "=",
      teamData: "=",
      rates: "=",
      controlling: "=",
      incomeImport: "=",
      controllingExport: "=",
      management: "=",
      profitability: "=",
      caseman: "=",
      matching: "=",
      sync: "=",
      config: "=",
      configUser: "=",
      configTeam: "=",
      configClient: "=",
      configPg: "=",
      video: "=?",
      klixVideoVisibility: "=?",
      bpeVideoVisibility: "=?",
      termsOfUse: "=?"
    },
    controller: bHeaderController,
    controllerAs: 'bHeader',
    bindToController: true
  };

  return directive;
}

class bHeaderController {
  constructor (Auth, Language, $scope, $location, API, $interval, $sce, Bundle) {
    'ngInject';
    this.$onInit = () => {
      this.Auth = Auth;
      this.$scope = $scope;
      this.$location = $location;
      this.$scope.currentNavItem = 'page1';
      this.$sce = $sce;
      this.API = API;
      this.Language = Language;
      this.languages = Language.getLanguages();
      this.language = Language.currentLanguage();
      this.Bundle = Bundle;
      this.changeLanguage = (language) => {
        this.Language.changeLanguage(language);
      };
      // TODO: CHANGE THIS SHIT
      this.version = window.frontendVersion;
      // this.version = "3.0.0";
      // END TODO CHANGE THIS SHIT
      this.isAdmin = this.$location.path().split('/')[1] === 'admin';


      if (localStorage.getItem('roedl-dark-background')) {
        document.querySelector('body').classList.add('darkerBackground');
      }
      // Krzysztof Controlling Logo Home Button Check
      [
        "/controlling/incomeImport",
        "/controlling/rates",
        "/controlling/export",
        "/stats/management/profitability",
        "/caseman/config",
        "/caseman/config/teams",
        "/caseman/config/team",
        "/caseman/config/users",
        "/caseman/config/teamUsers",
        "/caseman/config/clients",
        "/caseman/config/teamClients",
        "/caseman/config/processGroups",
        "/caseman/config/teamProcessGroups",
        "/caseman/matching",
        "/caseman/sync",
        "/terms-of-use"
      ].filter((x) => {return x == location.pathname;}).map(() => {
        this.isAVerySpecialPath = true;
      });

      [
        "/caseman/config/teams",
        "/caseman/config/team",
        "/caseman/config/processGroups",
        "/caseman/config/teamProcessGroups",
        "/caseman/matching"
      ].filter((x) => {return location.pathname.indexOf(x)>=0;}).map(() => {
        this.isAVerySpecialPath = true;
      });

      $interval(() => {
        if (document.getElementsByClassName('bSideBar__admin').length > 0) {
          if (document.getElementsByClassName('bSideBar__admin')[0].className === 'bSideBar__admin hidden') {
            this.logoIsVisible = true;
          } else {
            this.logoIsVisible = false;
          }
        }
      }, 100);

      this.setFeatureFlags();
    };
  }

  returnToHomeInCasesExplicitlyExplainedByKrzysztof() {
    if(this.isAVerySpecialPath){
      this.$location.path("/");
    }
  }

  setFeatureFlags() {
    if(!this.user.preferences || !this.user.preferences.featureFlags) {
      this.Auth.setFeatureFlagsToLocaleStorage(this.user).then( newUserInfo => {
        this.user = newUserInfo;
        this.setFFToValues();
      });
    } else {
      this.setFFToValues();
    }

    this.is360visible = this.view360FeatureFlag && this.user.canAccess360View && this.profitabilityViewFlag;
  }

  setFFToValues() {
    this.managementView = !!this.user.preferences.featureFlags.find(f => f == "ManagementView");
    this.profitabilityViewFlag = !!this.user.preferences.featureFlags.find(f => f == "ProfitabilityView");
    this.casemanFlag = !!this.user.preferences.featureFlags.find(f => f == "CASEmanInterfaceConfiguration");
    this.offerCalculatorFlag = !!this.user.preferences.featureFlags.find(f => f == "OfferCalculator");
    this.acceptanceHierarchyFlag = this.user.preferences.featureFlags.some(ff => ff === "AcceptanceHierarchy");
    this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(f => f === "OvertimeApplications");
    this.view360FeatureFlag = this.user.preferences.featureFlags.some(f => f == "View360");
    this.d365Flag = this.user.preferences.featureFlags.some(f => f == "D365Integration");
  }


  slugify(string) {
    return string.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  }

  clientProcessGroupsRoute() {
    return `/clients/${this.client.id}/${this.slugify(this.client.name)}/`;
  }

  goToClient() {
    this.$location.path(this.clientProcessGroupsRoute());
  }

  logout(){
    this.Auth.logout();
  }

  toggleBackground() {
    var selector = document.querySelector('body');
    if (selector.classList.value == 'darkerBackground') {
      selector.classList.remove('darkerBackground');
      localStorage.removeItem('roedl-dark-background');
    } else {
      selector.classList.add('darkerBackground');
      localStorage.setItem('roedl-dark-background', ' ');
    }
  }

  redirectToDocsCenter() {
    this.state = 'loading';
    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        this.Auth.getDocsPage().then((resp) => {
          if (resp && resp.status === 200) {
            const token = resp.data.token;
            const redirectUrl = this.$sce.trustAsResourceUrl(resp.data.uri);

            this.createAndSubmitForm(redirectUrl, {value: token});
            this.state = 'loaded';
          }
        },
        (error) => {
          this.state = 'error';
          this.error = error;
        });
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  createAndSubmitForm(path, params, method = 'post') {
    const form = document.createElement('form');
    form.method = method;
    form.action = path;
    form.target = '_blank';

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const inputField = document.createElement('input');
        inputField.type = 'hidden';
        inputField.name = 'token';
        inputField.value = params[key];

        form.appendChild(inputField);
      }
    }

    document.body.appendChild(form);
    form.submit();
    form.remove();
  }

  bundleBusinessEnterpriseRoedl(){
    return ['roedl', 'business', 'enterprise'].includes(this.Bundle.getBundleType());
  }

  isProfitabilityAvailable() {
    return this.bundleBusinessEnterpriseRoedl() && this.profitabilityViewFlag;
  }

  getManagementViewHref() {
    return this.acceptanceHierarchyFlag
      ? '/stats/management/worklogs'
      : this.isProfitabilityAvailable()
      ? '/stats/management/profitability'
      : this.is360visible && this.bundleBusinessEnterpriseRoedl()
      ? '/stats/management/360-view'
      : this.overtimeApplicationsFlag
      ? '/stats/management/overtimeRequest'
      : '/stats/management/export';
  }
}
